import type ViewType from "../store/schema/ViewType";
import { getUserConfiguration } from "owa-session-store";
import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";
import setMailOrganizationTypes from "../mutators/setMailOrganizationViewTypes";
import setReactListViewType from "../mutators/setReactListViewType";
import getLegacyRPConversationEnabledOption from "./getLegacyRPConversationEnabledOption";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

export default function initializeMailOrganizationSettings(): void {
    const userOptions = getUserConfiguration().UserOptions;
    if (userOptions && userOptions.GlobalListViewTypeReact != undefined) {
        setReactListViewType(userOptions.GlobalListViewTypeReact);
        
        // If rp-momocoSettings is enabled, we will not set the view types here
        // the types will be set in initializeMailOrganizationViewTypes
        if (!isGlobalFeatureEnabled("rp-momocoSettings")) {
            let readingPaneViewType = 3;
            let listViewExpansionType = 3;
            const isRPConversationEnabled = getLegacyRPConversationEnabledOption();
            switch (userOptions.GlobalListViewTypeReact) {
                case 0:
                    if (isRPConversationEnabled) {
                        listViewExpansionType = 0;
                        readingPaneViewType = 0;
                        break;
                    }
                    else {
                        listViewExpansionType = 1;
                        readingPaneViewType = 2;
                        break;
                    }
                case 1:
                    listViewExpansionType = 2;
                    readingPaneViewType = 2;
                    break;
                default:
                    // Default to conversation view
                    listViewExpansionType = 0;
                    readingPaneViewType = 0;
                    throw new Error("Invalid GlobalListViewTypeReact");
            }
            
            setMailOrganizationTypes(listViewExpansionType, readingPaneViewType);
        }
    }
}
